export default "__VITE_ASSET__o8902$0D__"